import { ISSOTrackingProps } from 'main/components/common/AuthModal/types'
import { UserSignUpSource, UserType } from 'main/util/user'

export type UserChooser<T> = [
  director: T | undefined,
  parent: T | undefined,
  fallback: T | undefined, // unknown, except not a reserved name
]
export function chooseByUserType<T>(type: UserType | undefined, choice: UserChooser<T> | T) {
  const getChoice = (index: number) => {
    if (Array.isArray(choice)) {
      return choice[index]
    } else {
      return choice
    }
  }
  return type === UserType.Director
    ? getChoice(0)
    : type === UserType.Parent
    ? getChoice(1)
    : getChoice(2)
}

export interface IOptionalTrackingData {
  schoolId?: number
  externalSchoolId?: number
  sessionId?: string
}
export function buildTracking(
  type: UserType | undefined,
  sourceChooser: UserChooser<UserSignUpSource> | UserSignUpSource | undefined,
  eventChooser: UserChooser<string> | string,
  extra?: IOptionalTrackingData,
) {
  return {
    source: chooseByUserType(type, sourceChooser),
    trackingData: {},
    segmentData: {
      event: chooseByUserType(type, eventChooser),
      data: {
        ...(extra?.schoolId ? { schoolId: extra.schoolId } : {}),
        ...(extra?.externalSchoolId ? { externalSchoolId: extra.externalSchoolId } : {}),
        ...(extra?.sessionId ? { sessionId: extra.sessionId } : {}),
      },
    },
  } as ISSOTrackingProps
}
